import { useTranslation } from 'react-i18next';
import type { Ownership } from '@gnosis/shared';

export function Spinner({ label }: { label?: string }) {
  return (
    <span className="inline-flex items-center gap-2 text-muted" role="status">
      <span
        aria-hidden="true"
        className="h-4 w-4 animate-spin rounded-full border-2 border-border border-t-accent"
      />
      {label}
    </span>
  );
}

// Couleur catégorielle par responsabilité (data viz assumée, hors tokens de thème).
const OWNERSHIP_DOT: Record<Ownership, string> = {
  FRITIC: 'bg-blue-500',
  ECOLE: 'bg-emerald-500',
  SITEL: 'bg-amber-500',
  TIERS: 'bg-fuchsia-500',
};

export function OwnershipBadge({ ownership, label }: { ownership: Ownership; label: string }) {
  const { t } = useTranslation();
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-surface-2 px-2 py-0.5 text-xs text-fg">
      <span aria-hidden="true" className={`h-2 w-2 rounded-full ${OWNERSHIP_DOT[ownership]}`} />
      {label}
      <span className="text-muted">· {t(`ownership.${ownership}`)}</span>
    </span>
  );
}

export function Chip({ children }: { children: React.ReactNode }) {
  return <span className="rounded-full bg-surface-2 px-2 py-0.5 text-xs text-muted">{children}</span>;
}
